import React from 'react';
import { useAuth } from '../AuthContext';
import VendorDashboard from '../pages/VendorDashboard';
import Spinner from './common/Spinner';

const VendorDashboardLayout = ({ children }) => {
  const { isAuthenticated } = useAuth();

  // Handle loading state
  if (!isAuthenticated) {
    return <Spinner />;
  }

  // If user is a regular vendor (no org_id), show normal dashboard
  if (isAuthenticated?.role === 'vendor' && !isAuthenticated?.org_id) {
    return <VendorDashboard />;
  }

  // For organizations or vendors under organizations
  return children;
};

export default VendorDashboardLayout; 